<template>
  <div class="dof-lottery-rain" :style="wrapStyle">
    <rain-item :key="i"
               :src="src"
               :rain-id="i"
               :ref="`rain-item-${i}`"
               @dofLotteryRainCaught="dofLotteryRainCaught"
               v-for="(src,i) in picList"></rain-item>
  </div>
</template>

<style scoped>
  .dof-lottery-rain {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(133, 11, 11, .8);
  }
</style>

<script>
  import RainItem from './rain-item.vue';

  export default {
    components: { RainItem },
    props: {
      picList: Array,
      config: Object,
      wrapStyle: Object
    },
    methods: {
      dofLotteryRainCaught (e) {
        this.$emit('dofLotteryRainCaught', { rainId: e.rainId });
      },
      destroy () {
        const { picList } = this;
        const length = picList.length;
        for (let i = 0; i < length; i++) {
          this.$refs[`rain-item-${i}`][0].destroy();
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// index.vue?6a6ced66